module.exports = __webpack_public_path__ + "img/GL.120a1835.svg";